<template>
  <v-container fluid>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <template v-else>
      <v-toolbar
        color="#eee"
        class="elevation-0 secondary--text mb-4"
        style="background: transparent"
      >
        <v-toolbar-title>Carteira Apetrus</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          @click="authenticationDialog = true"
          icon
          color="info"
        >
          <v-icon> compare_arrows </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card :loading="loading" class="ma-4 pa-4">
        <v-card-text v-if="carteira">
          <v-layout justify-center>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-avatar v-on="on" color="success" size="200">
                  <h1 v-if="carteira" class="white--text">
                    {{ carteira.saldo | currency({ fractionCount: 2 }) }}
                  </h1>
                </v-avatar>
              </template>
              <span>Saldo</span>
            </v-tooltip>
          </v-layout>
          <div class="headline grey--text pt-3 text-xs-center pt-5 mb-2">
            Histórico
          </div>
          <v-layout wrap justify-space-between>
            <v-flex xs11 md3>
              <v-select
                v-model="confirmado"
                :items="[
                  { text: 'Confirmados', value: true },
                  { text: 'Não confirmados', value: false },
                  { text: 'Todos', value: null }
                ]"
              />
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs5 md3>
              <v-select
                :items="itemsData"
                item-text="title"
                item-value="value"
                v-model="filtro_data"
              ></v-select>
            </v-flex>
            <v-flex xs5 md4>
              <v-menu
                  ref="menuData"
                  v-model="menuData"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-flex xs12>
                      <v-combobox
                        v-if="filtro_data === 'intervalo'"
                        v-model="intervalo_relatorio"
                        label="Dias"
                        multiple
                        persistent-hint
                        chips
                        small-chips
                        readonly
                        flat
                        prepend-icon="event"
                        required
                        v-on="on"
                      ></v-combobox>
                      <v-combobox
                        v-else-if="filtro_data === 'dia'"
                        v-model="data_relatorio"
                        label="Dia"
                        persistent-hint
                        chips
                        small-chips
                        readonly
                        flat
                        @blur="date = parseDate(data_relatorio)"
                        prepend-icon="event"
                        required
                        v-on="on"
                      ></v-combobox>
                      <v-combobox
                        v-else
                        v-model="mes_relatorio"
                        label="Mes"
                        persistent-hint
                        chips
                        small-chips
                        readonly
                        flat
                        @blur="month = parseDate(mes_relatorio)"
                        prepend-icon="event"
                        required
                        v-on="on"
                      ></v-combobox>
                    </v-flex>
                  </template>
                  <v-flex xs12>
                    <v-flex xs12>
                      <v-date-picker clearable v-show="filtro_data === 'intervalo'" multiple v-model="dates" type="date" color="primary" no-title @input="dataSelecionada"></v-date-picker>
                    </v-flex>
                    <v-flex xs12>
                      <v-date-picker clearable v-show="filtro_data === 'dia'" v-model="date" type="date" color="primary" no-title @input="dataSelecionada"></v-date-picker>
                    </v-flex>
                    <v-flex xs12>
                      <v-date-picker clearable v-show="filtro_data === 'mes'" v-model="month" type="month" color="primary" no-title @input="dataSelecionada"></v-date-picker>
                    </v-flex>
                  </v-flex>
                </v-menu>
            </v-flex>
          </v-layout>
          <v-list class="mb-2" v-if="historico">
            <v-list-tile
              two-line
              v-for="(transacao, index) in historico"
              :key="index"
              class="mb-2"
              style="border-bottom: 0.1em solid #dcdcdc"
            >
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ transacao.descricao }}
                </v-list-tile-title>
                <v-list-tile-sub-title
                  :class="
                    transacao.valor > 0 ? 'success--text' : 'error--text'
                  "
                >
                  {{ transacao.valor  | currency({ fractionCount: 2 }) }} ({{
                    transacao.data
                      .substr(0, 10)
                      .split("-")
                      .reverse()
                      .join("/")
                  }})
                </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <div class="text-xs-center pt-2">
          <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-card-text>
    </v-card>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
    </v-snackbar>
      <v-dialog v-model="authenticationDialog" v-if="authenticationDialog" persistent width="500">
        <smart-lock  @fechar="fechar()" @callDialog="autenticado = true, authenticationDialog = false, dialogTransferencia = true"></smart-lock>
      </v-dialog>
      <v-dialog v-model="dialogTransferencia" width="35em" v-if="autenticado && dialogTransferencia">
        <dialog-transferencia @transferirSaldo="transferirSaldo"></dialog-transferencia>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>

import DialogTransferencia from '@/components/dialogs/DialogTransferencia'
import SmartLock from '@/components/dialogs/SmartLock'
import SmartLockMessage from '@/components/SmartLockMessage'

export default {
  components: {
    DialogTransferencia,
    SmartLock,
    SmartLockMessage
  },
  data () {
    return {
      autenticado: false,
      authenticationDialog: false,
      carteira: null,
      historico: null,
      dialogTransferencia: false,
      menuData: false,
      confirmado: true,
      funcionarios: '',
      snackbar: {
        active: false,
        color: 'info',
        timeout: 4000,
        vertical: true,
        multiLine: true,
        text: ''
      },
      totalItems: 0,
      pagination: {
        rowsPerPage: 5,
        page: 1
      },
      dates: [],
      intervalo_relatorio: [],
      month: null,
      data_relatorio: null,
      mes_relatorio: null,
      date: null,
      filtro_data: 'dia',
      itemsData: [
        {
          title: 'Dia',
          value: 'dia'
        },
        {
          title: 'Mês',
          value: 'mes'
        },
        {
          title: 'Intervalo',
          value: 'intervalo'
        }
      ]
    }
  },
  watch: {
    headers () {
      this.criarCarteiraVirtual()
    },
    carteira () {
      if (this.carteira) {
        this.pegarHistorico()
      }
    },
    pagination: {
      handler (val) {
        this.pegarHistorico()
      },
      deep: true
    },
    date (val) {
      if (val) {
        this.data_relatorio = this.formatDate(this.date)
      }
    },
    month (val) {
      if (val) {
        this.mes_relatorio = this.formatDate(this.month)
      }
    },
    filtro_data (val) {
      if (val) {
        this.data_relatorio = null
        this.mes_relatorio = null
        this.intervalo_relatorio = []
      }
    },
    filtro () {
      this.pagination.page = 1
      this.pegarHistorico()
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    loading () {
      return this.$store.getters.loading
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    filtro () {
      const data = {}
      if (this.confirmado != null) {
        data.confirmado = this.confirmado
      }
      switch (this.filtro_data) {
        case 'dia':
          if (this.data_relatorio) data.data = this.data_relatorio
          break
        case 'mes':
          if (this.mes_relatorio) {
            const dataBusca = this.mes_relatorio.split('/')
            data.data__month = dataBusca[0]
            data.data__year = dataBusca[1]
          }
          break
        case 'intervalo':
          if (this.intervalo_relatorio.length > 1) {
            data.data__gte = this.intervalo_relatorio[0]
            data.data__lte = this.intervalo_relatorio[1]
          }
      }
      return data
    }
  },
  methods: {
    fechar () {
      this.authenticationDialog = false
    },
    orderDates () {
      this.dates.sort((a, b) => {
        a = new Date(a.split('-'))
        b = new Date(b.split('-'))
        return a < b ? -1 : a > b ? 1 : 0
      })
    },
    formatDate (date) {
      if (!date) return null

      if (this.filtro_data === 'dia' || this.filtro_data === 'intervalo') {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      } else {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      }
    },
    parseDate (date) {
      if (!date) return null

      if (this.filtro_data === 'dia' || this.filtro_data === 'intervalo') {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      }
    },
    dataSelecionada () {
      if (this.filtro_data === 'intervalo') {
        if (this.dates.length === 3) {
          let day1 = this.dates[0]
          let day2 = this.dates[2]
          this.dates = []
          this.dates = [day1, day2]
        }
        if (this.dates.length) {
          this.orderDates()
        }
        this.intervalo_relatorio = this.dates.map(this.formatDate)
      } else {
        this.menuData = false
      }
    },
    transferirSaldo (payload) {
      this.dialogTransferencia = false
      this.autenticado = false
      this.$store
        .dispatch('transferirSaldo', payload)
        .then(() => {
          this.snackbar.color = 'success'
          this.snackbar.text = `R$ ${payload.valor_pago} transferidos com sucesso`
          this.snackbar.active = true
          this.update()
        })
        .catch(() => {
          this.snackbar.color = 'error'
          this.snackbar.text =
            'Ocorreu um erro ao transferir o saldo. Tente novamente e entre em contato com a Apetrus, caso o erro persista'
          this.snackbar.active = true
        })
    },
    pegarHistorico () {
      const data = this.filtro
      data.page = this.pagination.page
      this.$store
        .dispatch('pegarHistoricoDaCarteiraVirtualAdm', data)
        .then((json) => {
          this.historico = json.results
          this.totalItems = json.count
        })
    },
    criarCarteiraVirtual () {
      this.$store
        .dispatch('pegarCarteiraVirtualAdm')
        .then((json) => {
          this.carteira = json
        })
    },
    update () {
      this.criarCarteiraVirtual()
      this.pegarHistorico()
    }
  },
  beforeMount () {
    if (this.headers) {
      this.update()
    }
  }
}
</script>

<style>
</style>
